/**
 * FeedbackSender — who sent a feedback item, linked to their admin profile (/users/:id).
 *
 * `user_email` is copied from the sign-in token when the member sends the item
 * (POST /v1/feedback in backend/src/index.ts). It is '' when the account has no
 * e-mail address. On 2026-10-17 DEV held 14 such items from 3 members: the Email
 * cell was blank (`'' ?? '--'` is ''), and nothing else on the page named the
 * sender, so an admin could not find or answer them. `user_id` is the real link
 * to the member. It is NULL only after the account is deleted (062: ON DELETE
 * SET NULL); erasure deletes the row itself (services/erasure-registry.ts).
 */
import { UserProfileLink } from '@/pages/matches/components/UserProfileLink';

export function FeedbackSender({ userId, userEmail }: { userId: string | null; userEmail: string | null }) {
  const email = userEmail && userEmail.trim() !== '' ? userEmail : null;
  if (!userId) return <>{email ?? '--'}</>;
  return <UserProfileLink userId={userId}>{email ?? 'No e-mail'}</UserProfileLink>;
}
